/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import React, { FC, useContext, useEffect } from 'react'
import { Redirect, Switch, Route } from 'react-router-dom'
import { MasterLayout } from '../../_metronic/layout/MasterLayout'
import { PrivateRoutes } from './PrivateRoutes'
import { Logout, AuthPage } from '../modules/auth'
import { ErrorsPage } from '../modules/errors/ErrorsPage'
import { useAuth } from '../contexts/CustomContextHook/useAuth'



const Routes = () => {
  // const isAuthorized = useSelector<RootState>(({auth}) => auth.user, shallowEqual)


  const { UserToken, setUserToken } = useAuth()




  useEffect(() => {




    document.addEventListener("keydown", function (event) {
        if (event.key === "Enter" &&  event.target.nodeName  === "INPUT") {
            var form = event.target.form;
            var index = Array.prototype.indexOf.call(form, event.target);
            if (form.elements[index + 1] !== undefined) {
                form.elements[index + 1].focus();
            }
            event.preventDefault();
        }
    })

  },[])




  const isAuthorized = new Date(UserToken.expiry) > new Date() && UserToken.token !== "";


  console.log('is Authorized :: ',isAuthorized);
  


  return (
    <Switch>
      {!isAuthorized ? (
        /*Render auth page when user at `/auth` and not authorized.*/
        <Route>
          <AuthPage />
        </Route>
      ) : (
        /*Otherwise redirect to root page (`/`)*/
        <Redirect from='/auth' to='/' />
      )}






      <Route path='/error' component={ErrorsPage} />
      <Route path='/logout' component={Logout} />

      {!isAuthorized ? (
        /*Redirect to `/auth` when user is not authorized*/
        <Redirect to='/auth/login' />
      ) : (
        <MasterLayout>
          <PrivateRoutes />
        </MasterLayout>
      )}
    </Switch>
  )
}

export { Routes }
